import { canv } from "@/canv/global";
import { PresentationWidget } from "@/elements/Presentation/Presentation";
import { PlayIcon } from "@/icons";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";

interface UsePresentationPlayButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function usePresentationPlayButton({
    setActiveSubMenu,
}: UsePresentationPlayButtonProps): MenuOptionResult {
    const handleClick = () => {
        setActiveSubMenu(null);
        const selectedEntities = canv.canvasController.selected;
        if (selectedEntities.length === 1 && selectedEntities[0].isItemWrapper()) {
            const child = selectedEntities[0].onlyChild();
            if (child && child instanceof PresentationWidget) {
                child.play();
            }
        }
    };

    return {
        content: <PlayIcon />,
        handleClick,
    };
}
